import {useEffect, useState} from "react";
import {mediaMatch} from "../../../utils";

export default function FixedBar({ children, className = '', style }) {
  const [scrolling, setScrolling] = useState(true);
  let timeout = null;
  let scrollEvent = null;
  
  useEffect(() => {
    if (document.body.offsetHeight < window.screen.height * 2) return;
    if (mediaMatch.isMdmax) return;
    
    scrollEvent = document.addEventListener('scroll', (e) => {
      
      if (timeout) return;
      
      setScrolling(false);
      
      timeout = setTimeout(() => {
        setTimeout(() => {
          setScrolling(true);
        }, 180);
        
        if (timeout) {
          timeout = null;
          clearTimeout(timeout);
        }
      }, 180);
      
    });
    
    return () => {
      if (scrollEvent) {
        document.removeEventListener('scroll');
        scrollEvent = null;
      }
    };
  }, []);
  
  return (
    <div style={{
      bottom: 0,
      transform: `translateY(${scrolling ? 0 : '200%'})`,
      transition: 'transform 0.3s',
      ...style,
    }}
         className={`md:hidden fixed left-0 container border-t py-[8px] px-[10px] bg-white ${className}`}>
      {children}
    </div>
  );
}
